import { useContext, useEffect, useState } from "react";
import Styles from "./LockScreen.module.scss";
import classnames from "classnames"
import { getTimeInFormat } from "../../../global/functions/functrions";

import { ReactComponent as PhoneIcon } from "../../../icons/mobile_menu_icons/phone.svg"
import { ReactComponent as CameraIcon } from "../../../icons/mobile_menu_icons/camera.svg"

import SleepIcon from "../../../icons/extra_icons/mac_sleep.webp"
import RestartIcon from "../../../icons/extra_icons/mac_restart.webp"
import ShutDownIcon from "../../../icons/extra_icons/mac_shut_down.webp"

import { useSwipeable } from "react-swipeable";
import { useDispatch } from "react-redux";
import { closeWindow } from "../../../actions";
import { APP_KEY_IDS } from "../../../constants/constants";
import { useTransition, animated } from "react-spring";
import { AuthContext } from "../../../contexts/AuthContext";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, googleAuthProvider } from "../../../useFirebaseInit";

interface LockScreenProps {
    isTransparentBg?: boolean;
}

const LockScreen = ({ isTransparentBg = false }: LockScreenProps) => {

    const { userId, userName, pfpUrl, email, setUser, isLoggedIn } = useContext(AuthContext)

    const [currentTime, setTime] = useState(new Date())

    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const dow = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    useEffect(() => {
        setInterval(() => {
            setTime(new Date())
        }, 1000)
    }, [userId, userName, email])

    const dispatch = useDispatch()

    const handleUnlock = () => {
        // if (isLoggedIn) {
        //     var comp: HTMLElement | null = document.getElementById("lock_screen")
        //     if (comp) { comp.style.opacity = "0" }
        //     setTimeout(() => {
        //         dispatch(closeWindow(APP_KEY_IDS.LOCK_SCREEN))
        //     }, 1000);
        // }
        // else {
        //     login()
        // }
        var comp: HTMLElement | null = document.getElementById("lock_screen")

        if (comp) { comp.style.opacity = "0" }
        setTimeout(() => {
            dispatch(closeWindow(APP_KEY_IDS.LOCK_SCREEN))
        }, 500);
    }

    const handler = useSwipeable({
        onSwiped: handleUnlock
    })

    const login = () => {
        signInWithPopup(auth, googleAuthProvider)
            .then((result) => {
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential?.accessToken;
                const user: any = result.user;

                if (user) {
                    setUser({
                        userName: user.displayName,
                        userId: user.uid,
                        pfpUrl: user.photoURL,
                        email: user.email,
                        isEmailVerified: user.emailVerified
                    })

                }
                dispatch(closeWindow(APP_KEY_IDS.LOCK_SCREEN))
            }).catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                const email = error.customData.email;
                const credential = GoogleAuthProvider.credentialFromError(error);
            });
    }

    

    const reload = () => {
        document.documentElement.style.setProperty(('--brightness'), '0');
        document.documentElement.style.setProperty(('--saturation'), '0');
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };

    const shutDown = () => {
        document.documentElement.style.setProperty(('--brightness'), '0');
        window.open("", "_self");
        window.close()
    };

    const Profiles = [
        {
            id: "dark_original",
            label: "Guest",
            pfp: "https://i.pinimg.com/564x/fb/e8/87/fbe8876f5662d42333312d3a0bb1d292.jpg",
            onClicked: handleUnlock
        }
    ]


    return (
        <div className={classnames(Styles.container, isTransparentBg && Styles.no_bg)} id={"lock_screen"}>
            <div className={Styles.mobile} {...handler}>
                <div className={Styles.top_details}>
                    <div className={Styles.time}>
                        {getTimeInFormat(currentTime)}
                    </div>
                    <div className={Styles.base_info}>
                        {`${dow[currentTime.getDay()]}, ${currentTime.getDate()} ${month[currentTime.getMonth()]}`}
                    </div>
                </div>

                <div className={Styles.info}>
                    {/* {userId==="-1" ? "Wait! Checking your login status" : "Swipe screen to unlock and login. If you have logged in already then kindly wait for a while. If you still cant login, try on a desktop as google faces issues with android devices "} */}
                    Swipe Screen to unlock
                </div>
                <div className={Styles.bottom_half}>
                    <div className={Styles.icon_container}>
                        <PhoneIcon />
                    </div>
                    <div className={Styles.icon_container}>
                        <CameraIcon />
                    </div>
                </div>
            </div>
            <div className={Styles.desktop}>
                <div className={Styles.top_details}>
                    <div className={Styles.profiles}>
                        {
                            Profiles.map((profile: any) => {
                                return (
                                    <div className={Styles.profile} key={profile.id} onClick={profile.onClicked}>
                                        <div className={Styles.pfp}><img src={profile.pfp} /></div>
                                        <div className={Styles.label}>{userName || profile.label}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={Styles.info}>
                        Click on the profile you want to login into
                    </div>
                </div>


                <div className={Styles.belongs_to}>{
                    isLoggedIn   ?
                        `This Mac belongs to ${userName && userName} : ${email && email}`
                        : `This Mac belongs to Priyansh Datyal : priyansh.sk80@gmail.com`

                }
                </div>



                <div className={Styles.bottom_half}>
                    <div className={Styles.bottom_options}>

                        <div className={Styles.option_container} onClick={() => { shutDown() }}>
                            <div className={Styles.icon_container}>
                                <img src={ShutDownIcon} />
                            </div>
                            <div className={Styles.label}>
                                Shut Down
                            </div>
                        </div>
                        <div className={Styles.option_container} onClick={() => { reload() }}>
                            <div className={Styles.icon_container}>
                                <img src={RestartIcon} />
                            </div>
                            <div className={Styles.label}>
                                Restart
                            </div>
                        </div>
                        <div className={Styles.option_container} onClick={() => { shutDown() }}>
                            <div className={Styles.icon_container}>
                                <img src={SleepIcon} />
                            </div>
                            <div className={Styles.label}>
                                SLeep
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LockScreen
